"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _config = require("@/api/admin/config/config");
var _message = require("@/libs/message");
var _tablePage = _interopRequireDefault(require("_c/CommonForm/table-page"));
var _vuex = require("vuex");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'config-manage',
  components: {
    TablePage: _tablePage.default
  },
  data: function data() {
    return {
      columns: [{
        label: '参数名称',
        prop: 'configName'
      }, {
        label: '参数键名',
        prop: 'configKey'
      }, {
        label: '参数键值',
        prop: 'configValue'
      }, {
        label: '系统内置',
        slot: 'configType'
      }, {
        label: '操作',
        slot: 'action'
      }],
      queryParams: {},
      dialogShow: false,
      delBtnDisabled: true,
      dialogTitle: '添加配置',
      form: {},
      rules: {
        configName: [this.$ruler('参数名称')],
        configKey: [this.$ruler('参数键名')],
        configValue: [this.$ruler('参数键值')],
        configType: [this.$ruler('系统内置')],
        remark: [this.$ruler('备注')]
      },
      configTypeOptionList: []
    };
  },
  methods: _objectSpread(_objectSpread({}, (0, _vuex.mapActions)(['getDictListByType'])), {}, {
    /**
     * 刷新
     */
    refresh: function refresh() {
      this.$refs.tablePage.refresh();
    },
    /**
     * 重置搜索条件
     */
    reset: function reset() {
      this.queryParams = {};
      this.$nextTick(function () {
        this.refresh();
      });
    },
    /**
     * 添加弹出框
     */
    addConfig: function addConfig() {
      this.dialogTitle = '添加配置';
      this.dialogShow = true;
    },
    /**
     * 修改弹出框
     * @param row
     */
    update: function update(row) {
      this.form = _objectSpread({}, row);
      this.dialogTitle = '修改配置';
      this.dialogShow = true;
    },
    /**
     * 点击每一行的checkbox
     */
    selectVal: function selectVal(ids) {
      this.ids = ids.map(function (val) {
        return val['id'];
      });
      this.delBtnDisabled = !this.ids.length;
    },
    /**
     * 批量删除
     */
    removeBatch: function removeBatch() {
      var _this = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _config.deleteBatchConfigById)(_this.ids).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          _this.refresh();
        });
      });
    },
    /**
     * 行内删除
     * @param row
     */
    remove: function remove(row) {
      var _this2 = this;
      (0, _message.ConfirmCustom)({
        type: 'warning'
      }).then(function () {
        (0, _config.deleteConfigById)(row.id).then(function (res) {
          if (res.data) {
            (0, _message.MessageSuccess)('del');
          } else {
            (0, _message.MessageError)('del');
          }
          // 刷新表格
          _this2.refresh();
        });
      });
    },
    /**
     * 重置表单
     * @param name
     */
    handleReset: function handleReset(name) {
      this.dialogShow = false;
      this.$refs[name].resetFields();
    },
    /**
     * 提交表单
     * @param name
     */
    handleSubmit: function handleSubmit(name) {
      var _this3 = this;
      this.$refs[name].validate(function (valid) {
        if (valid) {
          if (_this3.dialogTitle === '添加配置') {
            (0, _config.addConfig)(_this3.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('add');
              } else {
                (0, _message.MessageError)('add');
              }
              _this3.cancelDialogAndRefresh();
            });
          } else {
            (0, _config.updateConfig)(_this3.form).then(function (res) {
              if (res.data) {
                (0, _message.MessageSuccess)('upd');
              } else {
                (0, _message.MessageError)('upd');
              }
              _this3.cancelDialogAndRefresh();
            });
          }
        }
      });
    },
    /**
     * 关闭弹出框 和 刷新表格
     */
    cancelDialogAndRefresh: function cancelDialogAndRefresh() {
      // 清空表单
      this.handleReset('form');
      // 刷新表格
      this.refresh();
    }
  }),
  created: function created() {
    var _this4 = this;
    this.getDictListByType('config_type').then(function (res) {
      _this4.configTypeOptionList = res;
    });
  }
};